export enum User {
  GET_CURRENT_USER_REQUEST = '@user/GET_CURRENT_USER_REQUEST',
  GET_CURRENT_USER_SUCCESS = '@user/GET_CURRENT_USER_SUCCESS',
  GET_CURRENT_USER_FAIL = '@user/GET_CURRENT_USER_FAIL',

  GET_CURRENT_USER_CARD_REQUEST = '@user/GET_CURRENT_USER_CARD_REQUEST',
  GET_CURRENT_USER_CARD_SUCCESS = '@user/GET_CURRENT_USER_CARD_SUCCESS',
  GET_CURRENT_USER_CARD_FAIL = '@user/GET_CURRENT_USER_CARD_FAIL',

  GET_CURRENT_USER_AND_CARD_DETAIL_REQUEST = '@user/GET_CURRENT_USER_AND_CARD_DETAIL_REQUEST',
  GET_CURRENT_USER_AND_CARD_DETAIL_SUCCESS = '@user/GET_CURRENT_USER_AND_CARD_DETAIL_SUCCESS',
  GET_CURRENT_USER_AND_CARD_DETAIL_FAIL = '@user/GET_CURRENT_USER_AND_CARD_DETAIL_FAIL',

  UPLOAD_AVATAR_REQUEST = '@user/UPLOAD_AVATAR_REQUEST',
  UPLOAD_AVATAR_SUCCESS = '@user/UPLOAD_AVATAR_SUCCESS',
  UPLOAD_AVATAR_FAIL = '@user/UPLOAD_AVATAR_FAIL',

  GET_AVATAR_URL_REQUEST = '@user/GET_AVATAR_URL_REQUEST',
  GET_AVATAR_URL_SUCCESS = '@user/GET_AVATAR_URL_SUCCESS',
  GET_AVATAR_URL_FAIL = '@user/GET_AVATAR_URL_FAIL',

  DELETE_USER_REQUEST = '@user/DELETE_USER_REQUEST',
  DELETE_USER_SUCCESS = '@user/DELETE_USER_SUCCESS',
  DELETE_USER_FAIL = '@user/DELETE_USER_FAIL',

  UPDATE_CURRENT_USER_REQUEST = '@user/UPDATE_USER_REQUEST',
  UPDATE_CURRENT_USER_SUCCESS = '@user/UPDATE_USER_SUCCESS',
  UPDATE_CURRENT_USER_FAIL = '@user/UPDATE_USER_FAIL',

  UPDATE_USER_NAME_REQUEST = '@user/UPDATE_USER_NAME_REQUEST',
  UPDATE_USER_NAME_SUCCESS = '@user/UPDATE_USER_NAME_SUCCESS',
  UPDATE_USER_NAME_FAIL = '@user/UPDATE_USER_NAME_FAIL',

  UPDATE_USER_EMAIL_REQUEST = '@user/UPDATE_USER_EMAIL_REQUEST',
  UPDATE_USER_EMAIL_SUCCESS = '@user/UPDATE_USER_EMAIL_SUCCESS',
  UPDATE_USER_EMAIL_FAIL = '@user/UPDATE_USER_EMAIL_FAIL',

  UPDATE_USER_PASSWORD_REQUEST = '@user/UPDATE_USER_PASSWORD_REQUEST',
  UPDATE_USER_PASSWORD_SUCCESS = '@user/UPDATE_USER_PASSWORD_SUCCESS',
  UPDATE_USER_PASSWORD_FAIL = '@user/UPDATE_USER_PASSWORD_FAIL',

  UPDATE_SMS_REQUEST = '@user/UPDATE_SMS_REQUEST',
  UPDATE_SMS_SUCCESS = '@user/UPDATE_SMS_SUCCESS',
  UPDATE_SMS_FAIL = '@user/UPDATE_SMS_FAIL',

  RESEND_IDENTITY_VERIFICATION_CODE_REQUEST = '@user/RESEND_IDENTITY_VERIFICATION_CODE_REQUEST',
  RESEND_IDENTITY_VERIFICATION_CODE_SUCCESS = '@user/RESEND_IDENTITY_VERIFICATION_CODE_SUCCESS',
  RESEND_IDENTITY_VERIFICATION_CODE_FAIL = '@user/RESEND_IDENTITY_VERIFICATION_CODE_FAIL',

  UPDATE_IDENTITY_VERIFICATION_CODE_REQUEST = '@user/UPDATE_IDENTITY_VERIFICATION_CODE_REQUEST',
  UPDATE_IDENTITY_VERIFICATION_CODE_SUCCESS = '@user/UPDATE_IDENTITY_VERIFICATION_CODE_SUCCESS',
  UPDATE_IDENTITY_VERIFICATION_CODE_FAIL = '@user/UPDATE_IDENTITY_VERIFICATION_CODE_FAIL',

  UPDATE_DATE_OF_BIRTH_REQUEST = '@user/UPDATE_DATE_OF_BIRTH_REQUEST',
  UPDATE_DATE_OF_BIRTH_SUCCESS = '@user/UPDATE_DATE_OF_BIRTH_SUCCESS',
  UPDATE_DATE_OF_BIRTH_FAIL = '@user/UPDATE_DATE_OF_BIRTH_FAIL',

  UPDATE_PAYMENT_NOTIFICATION_METHOD_REQUEST = '@user/UPDATE_PAYMENT_NOTIFICATION_METHOD_REQUEST',
  UPDATE_PAYMENT_NOTIFICATION_METHOD_SUCCESS = '@user/UPDATE_PAYMENT_NOTIFICATION_METHOD_SUCCESS',
  UPDATE_PAYMENT_NOTIFICATION_METHOD_FAIL = '@user/UPDATE_PAYMENT_NOTIFICATION_METHOD_FAIL',

  GET_USER_INVITES_REQUEST = '@user/GET_USER_INVITES_REQUEST',
  GET_USER_INVITES_SUCCESS = '@user/GET_USER_INVITES_SUCCESS',
  GET_USER_INVITES_FAIL = '@user/GET_USER_INVITES_FAIL',

  ACCEPT_ALL_USER_INVITES_REQUEST = '@user/ACCEPT_ALL_USER_INVITES_REQUEST',
  ACCEPT_ALL_USER_INVITES_SUCCESS = '@user/ACCEPT_ALL_USER_INVITES_SUCCESS',
  ACCEPT_ALL_USER_INVITES_FAIL = '@user/ACCEPT_ALL_USER_INVITES_FAIL',

  GET_USER_YEARLY_STATS_REQUEST = '@user/GET_USER_YEARLY_STATS_REQUEST',
  GET_USER_YEARLY_STATS_SUCCESS = '@user/GET_USER_YEARLY_STATS_SUCCESS',
  GET_USER_YEARLY_STATS_FAIL = '@user/GET_USER_YEARLY_STATS_FAIL',

  GET_USER_PENDING_AND_EXPIRED_PAYMENT_STATS_REQUEST = '@user/GET_USER_PENDING_AND_EXPIRED_PAYMENT_STATS_REQUEST',
  GET_USER_PENDING_AND_EXPIRED_PAYMENT_STATS_SUCCESS = '@user/GET_USER_PENDING_AND_EXPIRED_PAYMENT_STATS_SUCCESS',
  GET_USER_PENDING_AND_EXPIRED_PAYMENT_STATS_FAIL = '@user/GET_USER_PENDING_AND_EXPIRED_PAYMENT_STATS_FAIL',

  GET_USER_LATEST_PAYOUTS_REQUEST = '@user/GET_USER_LATEST_PAYOUT_REQUEST',
  GET_USER_LATEST_PAYOUTS_SUCCESS = '@user/GET_USER_LATEST_PAYOUT_SUCCESS',
  GET_USER_LATEST_PAYOUTS_FAIL = '@user/GET_USER_LATEST_PAYOUT_FAIL',

  GET_USER_EXPIRED_PAYOUTS_REQUEST = '@user/GET_USER_EXPIRED_PAYOUTS_REQUEST',
  GET_USER_EXPIRED_PAYOUTS_SUCCESS = '@user/GET_USER_EXPIRED_PAYOUTS_SUCCESS',
  GET_USER_EXPIRED_PAYOUTS_FAIL = '@user/GET_USER_EXPIRED_PAYOUTS_FAIL',

  GET_USER_PENDING_PAYOUTS_REQUEST = '@user/GET_USER_PENDING_PAYOUTS_REQUEST',
  GET_USER_PENDING_PAYOUTS_SUCCESS = '@user/GET_USER_PENDING_PAYOUTS_SUCCESS',
  GET_USER_PENDING_PAYOUTS_FAIL = '@user/GET_USER_PENDING_PAYOUTS_FAIL',

  CLEAR_USER_INVITES = '@user/CLEAR_USER_INVITES',
}
